import { IS_DE_LANG_ENV } from '../../../config/env';
import {
    Dribble,
    Fb,
    Github,
    Ig,
    Ln,
    Youtube,
    Clutch,
    Glassdoor,
    Wtf,
    ProvenExpert,
    X,
} from '../../../images/footer/social-networks/components';

export const logos = [
    {
        src: Fb,
        alt: 'footer.social.logo.fb.alt',
        link: 'footer.social.logo.fb.link',
    },
    {
        src: Ln,
        alt: 'footer.social.logo.ln.alt',
        link: 'common.links.linkedIn',
    },
    {
        src: Youtube,
        alt: 'footer.social.logo.youtube.alt',
        link: 'footer.social.logo.youtube.link',
    },
    {
        src: Dribble,
        alt: 'footer.social.logo.dribble.alt',
        link: 'footer.social.logo.dribble.link',
    },
    {
        src: Github,
        alt: 'footer.social.logo.github.alt',
        link: 'footer.social.logo.github.link',
    },
    {
        src: Ig,
        alt: 'footer.social.logo.ig.alt',
        link: 'footer.social.logo.ig.link',
    },
    {
        src: X,
        alt: 'footer.social.logo.x.alt',
        link: 'footer.social.logo.x.link',
    },
    {
        src: Wtf,
        alt: 'footer.social.logo.wtf.alt',
        link: 'footer.social.logo.wtf.link',
    },
    {
        src: Clutch,
        alt: 'footer.social.logo.clutch.alt',
        link: 'footer.social.logo.clutch.link',
    },
    {
        ...(IS_DE_LANG_ENV
            ? {
                src: ProvenExpert,
                alt: 'footer.social.logo.provenExpert.alt',
                link: 'footer.social.logo.provenExpert.link',
            }
            :
            {
                src: Glassdoor,
                alt: 'footer.social.logo.glassdoor.alt',
                link: 'footer.social.logo.glassdoor.link',
            }),
    },
];
